<template>
    <div id="app">
        <TopBar
            @logout="logout"
            :isAuthenticated="auth.isAuthenticated()"
            :userProfile="stateUserProfile"
            :schools="stateSchools"
        />
         
        <div class="container-fluid">
            <div class="row">
                <div v-if="auth.isAuthenticated()" class="col-auto mt-2">
                    <Sidebar
                        :userProfile="stateUserProfile"
                        class="pl-5 pr-3"
                    />
                </div>

                <div class="col mt-4 learing-expending">
                    <!-- <img src="./assets/logo.png"> -->

                    <router-view />
                </div>
                
            </div>
        </div>

        
    </div>
</template>

<script>
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { State, Mutation, namespace } from 'vuex-class'

import TopBar from '@/components/common/TopBar'
import Sidebar from '@/components/common/Sidebar'


const appModule = namespace('app')

@Component({
    components: {
        TopBar,
        Sidebar
    }
})
export default class App extends Vue {
    @State('auth') auth
    @State('refererRouteLogin') refererRouteLogin
    @State('runRefreshToken') runRefreshToken
    @appModule.State('userProfile') stateUserProfile
    @appModule.State('schools') stateSchools

    @appModule.Action('onInit') actionOnInit

    @Mutation('setAuth') setAuth
    @Mutation('setRefererRouteLogin') setRefererRouteLogin

    created() {
        this.setAuth(this.$auth)

        /* if (!this.userLoggedIn) {
            this.setUserLoggedIn(localStorage.getItem('ytauth-user'))
        } */

        /** Check expire token for logout **/
        this.$http.interceptors.response.use(
            response => {
                return response
            },
            error => {
                console.log(
                    'interceptors response',
                    error,
                    this.auth.isAuthenticated()
                )
                // Do something with response error
                if (
                    error &&
                    error.response &&
                    error.response.status === 401 &&
                    this.auth.isAuthenticated() &&
                    !this.runRefreshToken
                ) {
                    console.log('unauthorized, logging out ...')
                    this.refreshToken()
                        .then(() => {
                            console.log(
                                'this.refererRouteLogin',
                                this.refererRouteLogin
                            )
                            // this.$router.push({ name: this.refererRouteLogin })

                            this.$router.go(0)
                        })
                        .catch(e => {
                            console.log(e)
                            this.logout()
                        })
                    return Promise.reject(error.response)
                }

                return Promise.reject(error)
            }
        )
    }

    mounted() {
        // Pre loaded schools list app
        this.actionOnInit()
    }

    logout() {
        this.$store.dispatch('logout').then(() => {
            console.log(this.$route)
            this.setRefererRouteLogin(this.$route.name)
            this.$router.push({ name: 'LoginPage' })
        })
    }

    refreshToken() {
        this.setRefererRouteLogin(this.$route.name)
        return this.$store.dispatch('refreshToken')
    }
    
}


// 


</script>

<style>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

h1 {
    font-size: 1.6rem;
}

.pop-out-enter-active,
.pop-out-leave-active {
    transition: all 0.5s;
}

.pop-out-enter,
.pop-out-leave-active {
    opacity: 0;
    transform: translateY(24px);
}
</style>



// WEBPACK FOOTER //
// src/App.vue